import { createFileRoute } from "@tanstack/react-router";
import MidwestFreight from "@/pages/corridors/MidwestFreight";

export const Route = createFileRoute("/corridors/midwest-freight")({ component: MidwestFreight });